<!-- Vendor marks, inline. Each viewBox is scaled to the requested size by the
     width/height bindings, so one copy serves every call site (list tile,
     detail header, chat connect card). No gradients: two flat brand blues
     stand in for Atlassian's gradient so repeated instances can't collide on
     a shared <defs> id. -->
@switch (key()) {

  @case ('atlassian') {
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 32 32" role="img" [attr.aria-label]="label() || name()">
      <path fill="#2684ff" d="M9.4 14.6a.8.8 0 0 0-1.36.13L.42 30a.83.83 0 0 0 .74 1.2h10.5a.8.8 0 0 0 .74-.46c2.26-4.67.9-11.78-3-16.14Z"/>
      <path fill="#0052cc" d="M15.1 1.1a18.3 18.3 0 0 0-1.07 18.06l5.05 10.09a.83.83 0 0 0 .74.46h10.5a.83.83 0 0 0 .74-1.2S16.7 1.72 16.45 1.2a.78.78 0 0 0-1.35-.1Z"/>
    </svg>
  }

  @case ('salesforce') {
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 32 23" role="img" [attr.aria-label]="label() || name()">
      <path fill="#00a1e0" d="M13.2 3.2A5.6 5.6 0 0 1 17.25 1.5a5.65 5.65 0 0 1 4.92 2.9 6.9 6.9 0 0 1 2.82-.6C28.86 3.8 32 6.97 32 10.88s-3.14 7.08-7.01 7.08a6.9 6.9 0 0 1-1.37-.14 5.13 5.13 0 0 1-4.48 2.65 5.06 5.06 0 0 1-2.23-.51 5.83 5.83 0 0 1-5.41 3.67 5.85 5.85 0 0 1-5.55-4.02 5.36 5.36 0 0 1-1.11.12A5.42 5.42 0 0 1 0 14.28a5.44 5.44 0 0 1 2.68-4.7 6.23 6.23 0 0 1-.52-2.49A6.26 6.26 0 0 1 8.41.82a6.2 6.2 0 0 1 4.79 2.4Z"/>
    </svg>
  }

  @case ('microsoft') {
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 32 32" role="img" [attr.aria-label]="label() || name()">
      <path fill="#f25022" d="M1 1h14.2v14.2H1z"/>
      <path fill="#7fba00" d="M16.8 1H31v14.2H16.8z"/>
      <path fill="#00a4ef" d="M1 16.8h14.2V31H1z"/>
      <path fill="#ffb900" d="M16.8 16.8H31V31H16.8z"/>
    </svg>
  }

  @case ('slack') {
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 122.8 122.8" role="img" [attr.aria-label]="label() || name()">
      <path fill="#e01e5a" d="M25.8 77.6a12.9 12.9 0 1 1-12.9-12.9h12.9v12.9zm6.5 0a12.9 12.9 0 0 1 25.8 0v32.3a12.9 12.9 0 0 1-25.8 0V77.6z"/>
      <path fill="#36c5f0" d="M45.2 25.8a12.9 12.9 0 1 1 12.9-12.9v12.9H45.2zm0 6.5a12.9 12.9 0 0 1 0 25.8H12.9a12.9 12.9 0 0 1 0-25.8h32.3z"/>
      <path fill="#2eb67d" d="M97 45.2a12.9 12.9 0 1 1 12.9 12.9H97V45.2zm-6.5 0a12.9 12.9 0 0 1-25.8 0V12.9a12.9 12.9 0 0 1 25.8 0v32.3z"/>
      <path fill="#ecb22e" d="M77.6 97a12.9 12.9 0 1 1-12.9 12.9V97h12.9zm0-6.5a12.9 12.9 0 0 1 0-25.8h32.3a12.9 12.9 0 0 1 0 25.8H77.6z"/>
    </svg>
  }

  @case ('catsy') {
    <!-- Icon-only crop of Catsy's real mark (catsy.com/assets/header/catsy-logo.svg)
         — the full asset is an icon+wordmark lockup; only the icon half fits a
         square tile, same treatment as every other icon-only mark above. -->
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 72 65" role="img" [attr.aria-label]="label() || name()">
      <path fill="#FFC718" d="M3.4,28.812a3.4,3.4,0,1,1-3.4,3.4,3.4,3.4,0,0,1,3.4-3.4"/>
      <path fill="#E6B100" d="M71.258,32.181v24.15a8.054,8.054,0,0,1-8.031,8.03h0a8.054,8.054,0,0,1-8.031-8.03V32.237l0-.056,0-.055v-.1A8.055,8.055,0,0,1,63.227,24h0a8.055,8.055,0,0,1,8.031,8.031v.15Z"/>
      <path fill="#4DD0C6" d="M63.227,0h0a8.054,8.054,0,0,1,8.03,8.031V32.125a8.055,8.055,0,0,1-8.03,8.031h0A8.055,8.055,0,0,1,55.2,32.125V8.031A8.055,8.055,0,0,1,63.227,0"/>
      <path fill="#8B6BFF" d="M40.526,9.508h0a8.055,8.055,0,0,1,11.357,0L68.921,26.545a8.055,8.055,0,0,1,0,11.357h0a8.054,8.054,0,0,1-11.357,0L40.526,20.865a8.055,8.055,0,0,1,0-11.357"/>
      <path fill="#FF6391" d="M68.941,26.526a8.055,8.055,0,0,1,0,11.357L51.9,54.92a8.055,8.055,0,0,1-11.357,0h0a8.053,8.053,0,0,1,0-11.356L57.583,26.526a8.054,8.054,0,0,1,11.358,0"/>
      <path fill="#930A5B" d="M69.223,37.585l-.017.019-.122.131-.144.148-.02.019a8.055,8.055,0,0,1-11.357,0l-5.677-5.678,5.7-5.7a8.053,8.053,0,0,1,10.88-.439l.459.458a8.062,8.062,0,0,1,.3,11.04"/>
      <path fill="#930A5B" d="M34.076,25.835A6.378,6.378,0,1,1,27.7,32.213a6.379,6.379,0,0,1,6.378-6.378"/>
      <path fill="#FF6391" d="M17.249,27.207a5.007,5.007,0,1,1-5.006,5.007,5.006,5.006,0,0,1,5.006-5.007"/>
    </svg>
  }

  @case ('github') {
    <svg [attr.width]="size()" [attr.height]="size()" viewBox="0 0 16 16" role="img" [attr.aria-label]="label() || name()">
      <path fill="#181717" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82a7.6 7.6 0 0 1 4 0c1.53-1.03 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8Z"/>
    </svg>
  }

  @default {
    <!-- No shipped mark: a stable monogram, tinted from a hash of the
         connector name so it never changes between renders. -->
    <span class="bm__mono"
          [style.width]="px()" [style.height]="px()"
          [style.font-size.px]="size() * 0.42"
          [style.background]="monoTint()"
          role="img" [attr.aria-label]="label() || name()">{{ mono() }}</span>
  }
}
